import _ from 'lodash';

const options = [
  {
    label: 'Asset Allocations',
    options: [
      {
        value: 'the Fund is currently investing outside its stated investment strategy asset allocation ranges.',
        followUp: [
          'the departure from the existing ranges is expected to be temporary and, over the medium term, the Fund\'s investments should return to within the normal ranges ',
          'there have been significant falls in value in some of the Fund\'s investments while others have retained their value.  The Trustee is currently assessing the extent to which general market improvements will return the Fund to its normal asset allocation ranges',
          'the Trustee has recently made a specific investment that has taken the Fund outside its normal asset allocation ranges',
          'in the future, the Trustee will use spare cash flow to make new investments that return the Fund to its normal asset allocation ranges',
          'the Fund is currently holding more cash than usual in view of the uncertain investment environment',
          'the Fund is currently  holding more cash than usual in anticipation of making a substantial investment shortly which is expected to return the Fund to the normal asset allocation ranges',
          'the Fund is currently holding more cash than usual as the Trustee has not identified suitable investment opportunities at this stage.  It is expected that the asset allocation will return to being in line with the investment strategy over the medium term once appropriate investments are found',
          'other',
        ],
      },
    ],
  },
  {
    label: 'Cash Flow',
    options: [
      {
        value: 'the Fund is currently experiencing cash flow issues in that it is in danger of being unable to meet',
        disabled: true,
        followUp: [
          'cash flow is expected to improve in the near term',
          'the Trustee is currently reviewing existing assets with a view to making appropriate disposals to free up cash',
          'other',
        ],
        children: [
          {
            value: 'borrowing costs as required under the original loan agreement',
            followUp: [
              'the Trustee is negotiating an adjustment to the loan terms',
            ],
          },
          {
            value: 'benefit payments to members',
            followUp: [
              'members have agreed to defer regular pension payments to reduce pressure on cash flow',
              'members have agreed to cease / commute pensions to reduce pressure on cash flow',
            ],
          },
          {
            value: 'normal fund and investment expenses',
            followUp: [
              'the Trustee is negotiating temporary reductions in Fund expenses until cash flow improves',
            ],
          },
          {
            value: 'other',
          },
        ],
      },
    ],
  },
  {
    label: 'Asset Values',
    options: [
      {
        value: 'the overall value of the Fund\'s assets has materially declined',
        followUp: [
          'the Trustee remains confident of the long term appropriateness of its investments',
          'the Trustee anticipates an improvement in values in the medium term but will continue to monitor this as part of a regular review of the Fund\'s investment strategy',
          'other',
        ],
      },
    ],
  },
  {
    label: 'Income',
    options: [
      {
        value: 'the Fund\'s income has materially declined.',
        disabled: true,
        followUp: [
          'the Trustee is confident that the Fund will still be able to meet relevant expenses and members\' benefits as and when they arise',
          'the Trustee believes the current arrangements remain the best option open to the Fund at this time despite the reduction in income',
          'the reduction in income is expected to be temporary and will return to previous levels over the longer term',
          'other',
        ],
        children: [
          {
            value: 'a major property asset has ceased producing income because it is untenanted',
          },
          {
            value: 'significant reductions in rent have been agreed for a major property asset in light of the current economic climate',
          },
          {
            value: 'significant assets within the Fund\'s equity portfolio have reduced income payments',
          },
          {
            value: 'other',
          },
        ],
      },
    ],
  },
  {
    label: 'Structural Changes',
    options: [
      {
        value: 'a new member has joined the Fund',
        followUp: [
          'the Trustee does not consider that the addition of a new member necessitates a change to the current investment approach',
          'the insurance requirements of the new member have been considered and the Trustee believes the approach adopted in the current investment strategy remains appropriate',
        ],
      },
      {
        value: 'a member has exited the Fund',
        followUp: [
          'the Trustee does not consider that the departure of one of its members requires a change to the current investment approach',
        ],
      },
      {
        value: 'one or more members have commenced drawing a pension from the Fund',
        followUp: [
          'the Trustee does not consider that a different investment approach is required following the commencement of pensions',
          'the Fund\'s cash flow under the current investment strategy is expected to be sufficient to meet pension payments as and when they fall due',

        ],
      },

    ],
  },
];

export const selectionModel = () => _.cloneDeep(options)
  .reduce((curr, prev) => {
    curr[prev.label] = {};
    prev.options.forEach((option) => {
      curr[prev.label][option.value] = {
        selection: option.children ? [] : false,
        other: '',
        followUp: [],
      };
    });
    return curr;
  }, {});

export const selectionModelCont = () => _.cloneDeep(options).reduce((curr, prev) => {
  curr[prev.label] = {
    selections: [],
    other: '',
  };

  return curr;
}, {});

export default options;
